/** Provider details as published on https://fairfleet.de/impressum (checked 2026-10-24). */
export const LEGAL_INFO = {
  company: "Fairfleet GmbH & Co. KG",
  street: "Robert-Bosch-Str. 15",
  city: "42489 Wülfrath",
  country: "Deutschland",
  managingDirector: "Heinrich Hecker",
  generalPartner: "Hecker Verwaltung GmbH",
  phone: "+49 20 58 77 82 10",
  email: "info@fairfleet.de",
  register: "AG Wuppertal, HRA 24878",
  generalPartnerRegister: "AG Wuppertal, HRB 29356",
  vatId: "DE323769344",
  imprintUrl: "https://fairfleet.de/impressum/",
  termsUrl: "https://fairfleet.de/agb/",
  privacyUrl: "https://fairfleet.de/datenschutz/",
} as const;
